import {
  DetailsHeader,
  DetailsList,
  DetailsRow,
  SelectionMode,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { columns } from './invitationGroupList/utility/getColumns';
import { listStyle } from './invitationGroupList/utility/styles';

export const InvitationGroupList = ({ items, onClick, onSelect }) => {
  const { t: translator } = useTranslation();

  return (
    <DetailsList
      compact={false}
      items={items}
      ariaLabel={translator('ariaLabel.invitationGroupListLabel')}
      selectionMode={SelectionMode.none}
      columns={columns(translator)}
      onRenderDetailsHeader={(props) => {
        return (
          <DetailsHeader
            {...props}
            styles={listStyle}
            ariaLabel={translator('ariaLabel.listHeader')}
          />
        );
      }}
      onRenderRow={(props) => {
        return <DetailsRow tabIndex="0" {...props} styles={listStyle} />;
      }}
      onItemInvoked={(item) => onClick(item.key)}
    />
  );
};
